import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { claimRewards } from "../apis/blockchain";
import { Web3Context } from "../contexts/Web3Context";
import CrossCloseButton from "./parts/CrossCloseButton";

export default function () {
  const web3Context = useContext(Web3Context);
  const pid = useSelector((state) => state.modal.data.pid);
  const amount = useSelector((state) => state.modal.data.claim);

  const submit = async (e) => {
    e.preventDefault();

    await claimRewards(web3Context.web3.rAskoFarmContract, pid);
    window.location.reload(false);
  };

  return (
    <div className="modal modal_w550 farm-modal farm-modal_pp">
      <CrossCloseButton className="custom-cross-btn_black close_btn" />
      <div className="farm-modal__controls">
        <button
          onClick={submit}
          className="custom-gradient-btn custom-gradient-btn_inverse farm-modal__btn"
        >
          <span>Claim</span>
        </button>
        <button className="farm-modal__rewards-btn">
          Total Rewards: {amount}
        </button>
      </div>
    </div>
  );
}
